export default defineNuxtPlugin((nuxtApp) => {
  const allowCookie = useLocalStorage('allow-cookie', {
    cookie1: false,
    cookie2: false,
    cookie3: false,
  })

  // connected or not, in the dataLayer before GTM starts and again at every sign-in / sign-out
  const { authenticated } = useAuthenticated()
  watch(authenticated, (connected) => trackLoginStatus(connected), {
    immediate: true,
  })

  // GTM sends the GA4 page_view on this event (tag GA4_Event_PageView). Nuxt writes the new <title> right after
  // page:finish: a history-change trigger fires at the pushState and recorded the title of the previous page.
  // page:finish also runs at the hydration, before GTM starts: GTM replays the queued event once it starts.
  // One page view per URL, even when nested pages each finish.
  const router = useRouter()
  let lastPage = ''
  nuxtApp.hook('page:finish', () => {
    setTimeout(() => {
      const page = router.currentRoute.value.fullPath
      if (page === lastPage) return
      lastPage = page
      track('page_ready')
    }, 0)
  })

  // A returning visitor who accepted the cookies used to start GTM and the Meta/X pixels before the hydration:
  // their long tasks (fbevents.js ~160 ms, its config ~125 ms, GTM ~90 ms on a mid-range phone) landed right
  // when the visitor starts tapping, delaying the response to the first taps (INP of the home at 211 ms).
  // onNuxtReady starts them once the page is hydrated and the browser is idle; the page view is still sent
  // (useHead needs the Nuxt context, which the idle callback has lost).
  onNuxtReady(() =>
    nuxtApp.runWithContext(() => {
      if (allowCookie.value.cookie2) {
        const { initialize } = useGtag()
        initialize()
      }

      if (allowCookie.value.cookie3) {
        const pixelConsent = useConsent()
        const metaTracker = usePixelMeta()
        const twitterTracker = usePixelTwitter()
        pixelConsent.grantConsent()
        metaTracker.enable()
        twitterTracker.enable()
      }
    }),
  )
})
